<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Выбрать технику</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" v-model="valid" :lazy-validation="false">
            <v-autocomplete
              v-model="form.vehicle_id"
              :items="vehicles"
              hide-no-data
              hide-selected
              item-text="name"
              item-value="id"
              label="Техника"
              placeholder="Выбрать"
              :rules="vehicleRules"
            ></v-autocomplete>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">Закрыть</v-btn>
        <v-btn color="primary" @click="onSubmit" :loading="submitting">Выбрать</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SelectVehicleDialog",
  data() {
    return {
      item: null,
      dialog: false,
      vehicles: [],
      form: {
        vehicle_id: null
      },
      valid: true,
      vehicleRules: [v => !!v || "не может быть пустым"],
      submitting: false
    };
  },
  methods: {
    open(vehicles) {
      if (this.$refs.form) this.$refs.form.reset();
      this.vehicles = vehicles;
      this.form = {
        vehicle_id: null
      };

      this.dialog = true;
      this.fetchData();
    },
    close() {
      this.form = { vehicle_id: null };
      this.dialog = false;
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit("select", this.form.vehicle_id);
        this.close();
      }
    }
  }
};
</script>